var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DefaultHeader'),_c('StepsHeader'),_c('router-view',{staticClass:"route-container m-t-30"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }